export default "__VITE_ASSET__B44Ja2ac__"